module.exports = __webpack_public_path__ + "static/Snapcard-c3a5a9808f318e7c2766fd09a851617d.png";